import { Injectable } from "@angular/core";

import { MediaCommandModel, MediaViewModel } from "src/app/core/models/media-model";
import { LanguageReferenceModel } from "src/app/core/models/reference-model/reference-media-model";
import { TranslationMediaView } from "./translation-media.view";
import { TranslationMediaChildView } from "./translation-media-child.view";
import { MediaContentCommandModel, MediaContentViewModel } from "src/app/core/models/media-model/media-content";

@Injectable()
export class TranslationMediaMapperService {

    constructor() {
    }

    public mediaToTranslationFileViews(models: MediaViewModel[]): TranslationMediaView[] {
        let views: TranslationMediaView[] = new Array();
        if (models) {
            let i = 0;
            for (let model of models) {
                var mediaContentPrimary = this.findMediaContentPrimaryLanguagemodel(model);
                if (mediaContentPrimary) {
                    if (!mediaContentPrimary.mediaText) {
                        ++i;
                        views.push(this.mediaToTranslationFileView(i, model));
                    }
                }
            }
        }
        return views;
    }

    private mediaToTranslationFileView(i: number, model: MediaViewModel): TranslationMediaView {
        let view = new TranslationMediaView();
        view.no = i;
        view.mediaId = model.mediaId;
        view.mediaName = model.mediaName;
        view.mediaTypeCode = model.mediaTypeCode;
        view.mediaTypeName = model.mediaTypeName;
        if (model.mediaContents) {
            var filter = model.mediaContents.filter(x => x.primaryLanguageFlag == true);
            if (filter.length > 0) {
                view.mediaContentId = filter[0].mediaContentId;
            }
        }
        return view;
    }

    public mediaToTranslationFileChildViews(models: MediaViewModel[],
        languageReferences: LanguageReferenceModel[]): TranslationMediaChildView[] {
        let views: TranslationMediaChildView[] = new Array();
        if (models) {
            let i = 0;
            for (let model of models) {
                var mediaContentPrimary = this.findMediaContentPrimaryLanguagemodel(model);
                if (!mediaContentPrimary?.mediaText) {
                    var primaryLanguageCode = this.findMediaContentPrimaryLanguage(model);
                    for (let language of languageReferences) {
                        if (language.languageCode != primaryLanguageCode) {
                            ++i
                            views.push(this.mediaToTranslationFileChildView(i, model, language));
                        }
                    };
                }
            }
        }
        return views;
    }

    private mediaToTranslationFileChildView(i: number, model: MediaViewModel, language: LanguageReferenceModel): TranslationMediaChildView {
        let view = new TranslationMediaChildView();
        view.no = i;
        view.mediaId = model.mediaId;
        view.mediaName = model.mediaName;
        view.languageCode = language.languageCode
        view.languageName = language.languageName
        view.mediaTypeCode = model.mediaTypeCode;
        view.noFile = true;
        if (model.mediaContents) {
            var filterTranslationText = model.mediaContents.filter(x => x.languageCode == language.languageCode);
            if (filterTranslationText.length > 0) {
                view.mediaContentId = filterTranslationText[0].mediaContentId;
                view.noFile = false;
            }
        }
        return view;
    }

    private findMediaContentPrimaryLanguage(model: MediaViewModel): string {
        if (model.mediaContents) {
            var filter = model.mediaContents.filter(x => x.primaryLanguageFlag == true);
            if (filter.length > 0) {
                return filter[0].languageCode;
            }
        }
    }

    public mediaTranslationToMediaModels(mediaTranslations: TranslationMediaChildView[], medias: MediaCommandModel[]): MediaCommandModel[] {
        if (medias) {
            for (let media of medias) {
                var mediaId = this.getMediaId(media);
                var filterMedia = mediaTranslations?.filter(x => x.mediaId == mediaId && x.noFile == false);
                if (filterMedia?.length > 0) {
                    media.mediaContents = this.mediaTranslationToMediaContentModels(filterMedia, media);
                }
            }
        }
        return medias;
    }

    private getMediaId(media: MediaCommandModel): string {
        if (media.mediaId) {
            return media.mediaId;
        }
        else {
            return media.mediaTranslationId;
        }
    }

    private mediaTranslationToMediaContentModels(mediaTranslations: TranslationMediaChildView[], media: MediaCommandModel): MediaContentCommandModel[] {
        if (mediaTranslations) {
            for (let textTranslation of mediaTranslations) {
                media.mediaContents.push(this.mediaTranslationToMediaContentModel(textTranslation, media.mediaTranslationId))
            }
        }
        return media.mediaContents;
    }

    private mediaTranslationToMediaContentModel(mediaTranslation: TranslationMediaChildView, mediaTranslationId: string): MediaContentCommandModel {
        let model = new MediaContentCommandModel();
        if (mediaTranslation) {
            if (mediaTranslation.mediaContentId && !mediaTranslationId) {
                model.mediaContentId = mediaTranslation.mediaContentId;
            }
            model.languageCode = mediaTranslation.languageCode;
            model.mediaFileBase64 = mediaTranslation.mediaFileBase64;
            model.primaryLanguageFlag = false;
        }
        return model;
    }

    public mediaFileLibraryToTranslationFileViews(models: MediaViewModel[], mediaTranslationTexts: TranslationMediaView[]): TranslationMediaView[] {
        if (models) {
            let i = mediaTranslationTexts.length;
            for (let model of models) {
                ++i;
                mediaTranslationTexts.push(this.mediaToTranslationFileView(i, model));
            }
        }
        return mediaTranslationTexts;
    }

    public mediaTextToTranslationTextChildViews(models: MediaViewModel[], languageReferences: LanguageReferenceModel[],
        mediaTranslationChildTexts: TranslationMediaChildView[]): TranslationMediaChildView[] {
        if (models) {
            let i = mediaTranslationChildTexts.length;
            for (let model of models) {
                var primaryLanguageCode = this.findMediaContentPrimaryLanguage(model);
                for (let language of languageReferences) {
                    if (language.languageCode != primaryLanguageCode) {
                        ++i
                        mediaTranslationChildTexts.push(this.mediaToTranslationFileChildView(i, model, language));
                    }
                };
            }
        }
        return mediaTranslationChildTexts;
    }

    public mediaFileLibraryDeleteTranslationFileViews(mediaId: string, mediaTranslationFiles: TranslationMediaView[]): TranslationMediaView[] {
        if (mediaId) {
            var mediaDelete = mediaTranslationFiles.filter(x => x.mediaId == mediaId);
            if (mediaDelete.length > 0) {
                mediaTranslationFiles.splice(mediaTranslationFiles.indexOf(mediaDelete[0]), 1);
                let i = 0;
                for (let media of mediaTranslationFiles) {
                    ++i;
                    media.no = i;
                }
            }
        }
        return mediaTranslationFiles;
    }

    public mediaFileLibraryDeleteTranslationChildFileViews(mediaId: string, mediaTranslationChildFiles: TranslationMediaChildView[]): TranslationMediaChildView[] {
        if (mediaId) {
            var mediaDeletes = mediaTranslationChildFiles.filter(x => x.mediaId == mediaId);
            for (let mediaDelete of mediaDeletes) {
                mediaTranslationChildFiles.splice(mediaTranslationChildFiles.indexOf(mediaDelete), 1);
            }
            let i = 0;
            for (let media of mediaTranslationChildFiles) {
                ++i;
                media.no = i;
            }
        }
        return mediaTranslationChildFiles;
    }

    private findMediaContentPrimaryLanguagemodel(model: MediaViewModel): MediaContentViewModel {
        if (model.mediaContents) {
            var filter = model.mediaContents.filter(x => x.primaryLanguageFlag == true);
            if (filter.length > 0) {
                return filter[0]
            }
        }
    }
}